import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/keyboard/backspace.svg'
import _imports_1 from '@/assets/keyboard/tab.svg'
import _imports_2 from '@/assets/keyboard/capslock.svg'
import _imports_3 from '@/assets/keyboard/return.svg'
import _imports_4 from '@/assets/keyboard/shift.svg'


const _withScopeId = n => (_pushScopeId("data-v-0c0d89bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"message non-selection\" data-v-0c0d89bb><div class=\"text\" data-v-0c0d89bb></div><div class=\"bar\" data-v-0c0d89bb></div></div><div class=\"container reveal\" id=\"container\" data-v-0c0d89bb><div class=\"number-line line\" data-v-0c0d89bb><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>`</span></div><div class=\"btm key key-1\" data-v-0c0d89bb><span data-v-0c0d89bb>1</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>2</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>3</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>4</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>5</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>6</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>7</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>8</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>9</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>0</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>-</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>=</span></div><div class=\"btm delete modify right-modify\" data-v-0c0d89bb><img src=\"" + _imports_0 + "\" alt=\"#\" data-v-0c0d89bb></div></div><div class=\"first-line line\" data-v-0c0d89bb><div class=\"btm tab modify left-modify\" data-v-0c0d89bb><img src=\"" + _imports_1 + "\" alt=\"#\" data-v-0c0d89bb></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>Q</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>W</span></div><div class=\"btm key key-e\" data-v-0c0d89bb><span data-v-0c0d89bb>E</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>R</span></div><div class=\"btm key key-t\" data-v-0c0d89bb><span data-v-0c0d89bb>T</span></div><div class=\"btm key key-y\" data-v-0c0d89bb><span data-v-0c0d89bb>Y</span></div><div class=\"btm key key-u\" data-v-0c0d89bb><span data-v-0c0d89bb>U</span></div><div class=\"btm key key-i\" data-v-0c0d89bb><span data-v-0c0d89bb>I</span></div><div class=\"btm key key-o\" data-v-0c0d89bb><span data-v-0c0d89bb>O</span></div><div class=\"btm key key-p\" data-v-0c0d89bb><span data-v-0c0d89bb>P</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>[</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>]</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>|</span></div></div><div class=\"second-line line\" data-v-0c0d89bb><div class=\"btm caplock modify left-modify\" data-v-0c0d89bb><img src=\"" + _imports_2 + "\" alt=\"#\" data-v-0c0d89bb></div><div class=\"btm key key-a\" data-v-0c0d89bb><span data-v-0c0d89bb>A</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>S</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>D</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>F</span></div><div class=\"btm key key-g\" data-v-0c0d89bb><span data-v-0c0d89bb>G</span></div><div class=\"btm key key-h\" data-v-0c0d89bb><span data-v-0c0d89bb>H</span></div><div class=\"btm key key-j\" data-v-0c0d89bb><span data-v-0c0d89bb>J</span></div><div class=\"btm key key-k\" data-v-0c0d89bb><span data-v-0c0d89bb>K</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>L</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>;</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>&#39;</span></div><div class=\"btm enter modify right-modify\" data-v-0c0d89bb><img src=\"" + _imports_3 + "\" alt=\"#\" data-v-0c0d89bb></div></div><div class=\"third-line line\" data-v-0c0d89bb><div class=\"btm shift shift-left modify left-modify\" data-v-0c0d89bb><img src=\"" + _imports_4 + "\" alt=\"#\" data-v-0c0d89bb></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>Z</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>X</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>C</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>V</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>B</span></div><div class=\"btm key key-n\" data-v-0c0d89bb><span data-v-0c0d89bb>N</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>M</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>,</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>.</span></div><div class=\"btm key\" data-v-0c0d89bb><span data-v-0c0d89bb>/</span></div><div class=\"btm shift shift-right modify right-modify\" data-v-0c0d89bb><img src=\"" + _imports_4 + "\" alt=\"#\" data-v-0c0d89bb></div></div></div>", 2)

import { onMounted } from "vue";
import { getAnalytics, logEvent } from "firebase/analytics";
import anime from "animejs";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let oneShotFlag = false;
let analytics = getAnalytics();

onMounted(() => {
  window.addEventListener("scroll", () => {
    const container = document.getElementById("container");
    const position = Math.floor(window.innerHeight - 64 * 4);
    if (container != null) {
      let offsetTop = Math.floor(container.getBoundingClientRect().top);
      if (offsetTop < position && oneShotFlag == false) {
        sendEvent();
        startShowingKeyboard();
      }
    }
  });
});

function sendEvent() {
  logEvent(analytics, "showApplicationMessage", {
    date: Date.now(),
  });
}

function startShowingKeyboard() {
  oneShotFlag = true;

  const tl = anime.timeline({});
  tl.add({
    targets: ".btm",
    opacity: [0, 1],
    translateY: function () {
      return [anime.stagger(-60, { grid: [15, 1], from: "last" }), 0];
    },
    duration: function () {
      return anime.random(600, 1200);
    },
    delay: function (el, i, length) {
      return 240 * ((length - i) / 14);
    },
    easing: "easeInOutCirc",
  });
  tl.add({
    targets: ".btm > span, .btm > img",
    opacity: [0, 1],
    duration: 200,
    easing: "easeInOutSine",
    complete: () => {
      startEnjoyTypingAnimation();
      animateBar();
    },
  });
}

function animateBar() {
  anime({
    targets: ".message .bar",
    duration: 800,
    opacity: [0.0, 1.0, 0.0],
    easing: "steps(1)",
    loop: true,
  });
}

const inputAnimationTime = 140;
const nextInputDelayTime = 100;
function startEnjoyTypingAnimation() {
  const tl = anime.timeline({
    duration: inputAnimationTime,
    delay: nextInputDelayTime,
    easing: "easeInOutSine",
  });

  tl.add({
    targets: ".key-e",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("E");
    },
  });
  tl.add({
    targets: ".key-n",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("EN");
    },
  });
  tl.add({
    targets: ".key-j",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJ");
    },
  });
  tl.add({
    targets: ".key-o",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJO");
    },
  });
  tl.add({
    targets: ".key-y",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJOY ");
    },
  });
  tl.add(
    {
      targets: ".key-t",
      scale: [1.0, 0.9, 1.0],
      complete: function () {
        setMessageText("ENJOY T");
      },
    },
    "+=500"
  );
  tl.add({
    targets: ".key-y",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJOY TY");
    },
  });
  tl.add({
    targets: ".key-p",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJOY TYP");
    },
  });
  tl.add({
    targets: ".key-i",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJOY TYPI");
    },
  });
  tl.add({
    targets: ".key-n",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJOY TYPIN");
    },
  });
  tl.add({
    targets: ".key-g",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJOY TYPING");
    },
  });
  tl.add({
    targets: ".key-1, .shift-right",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("ENJOY TYPING!");
      deleteTextAnimation();
    },
  });
}

function deleteTextAnimation() {
  const tl = anime.timeline({
    targets: ".delete",
    duration: 100,
    endDelay: 50,
  });
  tl.add({
    duration: 1000,
    scale: [1.0],
  });
  for (let index = 0; index < "ENJOY TYPING!".length; index++) {
    tl.add({
      scale: [1.0, 0.9, 1.0],
      complete: function () {
        let dom = document.querySelector(".message .text");
        if (dom != null) {
          dom.innerHTML = dom.innerHTML.slice(0, -1);
        }
      },
    });
  }
  tl.add({
    duration: 1000,
    scale: [1.0],
    complete: function () {
      startThankYouAnimation();
    },
  });
}

function startThankYouAnimation() {
  const tl = anime.timeline({
    duration: inputAnimationTime,
    delay: nextInputDelayTime,
    easing: "easeInOutSine",
  });

  tl.add({
    targets: ".key-t",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("T");
    },
  });
  tl.add({
    targets: ".key-h",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("TH");
    },
  });
  tl.add({
    targets: ".key-a",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("THA");
    },
  });
  tl.add({
    targets: ".key-n",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("THAN");
    },
  });
  tl.add({
    targets: ".key-k",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("THANK ");
    },
  });
  tl.add(
    {
      targets: ".key-y",
      scale: [1.0, 0.9, 1.0],
      complete: function () {
        setMessageText("THANK Y");
      },
    },
    "+=500"
  );
  tl.add({
    targets: ".key-o",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("THANK YO");
    },
  });
  tl.add({
    targets: ".key-u",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("THANK YOU");
    },
  });
  tl.add({
    targets: ".key-1, .shift-right",
    scale: [1.0, 0.9, 1.0],
    complete: function () {
      setMessageText("THANK YOU!");
    },
  });
}

function setMessageText(text: string): void {
  let dom = document.querySelector(".message .text");
  if (dom != null) {
    dom.innerHTML = text;
  }
}

return (_ctx: any,_cache: any) => {
  return _hoisted_1
}
}

})